/*
 * LL Kaufkasten-Kopf (Marian 2026-11-03): Umschalter „Für eine Person“ | „Für die ganze Familie“ und Preisleiter mit
 * Stand aus dem Warenkorb. Im Familien-Modus wandert <ll-familie> (ll-familie.js) in den Kaufkasten und der Kaufbereich
 * bekommt data-llkk-modus="familie"; die Theme-Bausteine für ein Teil blendet das CSS dann aus. Die Wahl merkt sich die
 * Sitzung, damit ein Zurück vom Warenkorb nicht wieder auf „eine Person“ springt.
 */
(function () {
  if (customElements.get('ll-kaufkasten')) return;

  function sitzung(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; }
    return null;
  }
  /* Galerie auf die angeklickte Farbe (Marian 2026-11-04: „was man als letzte Farbe angeklickt hat, das Bild ist zu sehen“).
     Farbcode aus der SKU (PRA-0073-HD-C223-XS → C223), dann das passende Vorschaubild der Galerie anklicken: Kinder-Model,
     sonst Kinder-Rücken, sonst irgendein Foto der Farbe (nie Baby). Nur Farben des Produkts oben, fremde Motive bleiben außen vor. */
  function galerieFarbe(farbe) {
    var daten = document.querySelector('[data-llf-produkt]'), p;
    try { p = JSON.parse(daten.textContent); } catch (x) { return; }
    var fi = (p.optionen || []).findIndex(function (o) { return /farbe|color/i.test(o); });
    if (fi < 0) return;
    var v = (p.varianten || []).filter(function (x) { return x.o[fi] === farbe && x.sku; })[0];
    var t = v ? String(v.sku).split('-') : [], code = t.length >= 4 ? t[3].toUpperCase() : null;
    if (!code) return;
    var daumen = Array.prototype.slice.call(document.querySelectorAll('.product-gallery__thumbnail:not([hidden])'));
    var name = function (b) { var i = b.querySelector('img'); return i ? String(i.currentSrc || i.src || '').split('?')[0].split('/').pop().toUpperCase() : ''; };
    var such = function (teil) { return daumen.filter(function (b) { var n = name(b); return n.indexOf('-' + code + teil) >= 0 && n.indexOf('BABY') < 0; })[0]; };
    var ziel = such('-KIDS-MODEL') || such('-KIDS-BACK') || such('-KIDS') || such('-');
    if (ziel && ziel.getAttribute('aria-current') !== 'true') ziel.click();
  }
  window.LLGalerieFarbe = galerieFarbe;
  if (!window.__llGalerieHaken) {
    window.__llGalerieHaken = true;
    /* Familien-Wähler: Farbkachel einer Person, deren Motiv das Produkt oben ist. Einfang-Phase, weil der Wähler beim Klick neu baut. */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('ll-familie [data-a="farbe"]');
      if (!b) return;
      var fam = b.closest('ll-familie'), person = b.closest('[data-i]'), haupt = document.querySelector('ll-kaufkasten');
      var pr = fam && fam.personen && person ? fam.personen[Number(person.getAttribute('data-i'))] : null;
      if (pr && haupt && pr.produkt && pr.produkt.h !== haupt.getAttribute('data-handle')) return;
      var farbe = b.getAttribute('data-v');
      setTimeout(function () { galerieFarbe(farbe); }, 30);
    }, true);
    /* „Ein Teil“: Farbwahl über den Varianten-Wähler des Themes. */
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant, d = document.querySelector('[data-llf-produkt]'), p;
      if (!v || !d) return;
      try { p = JSON.parse(d.textContent); } catch (x) { return; }
      var fi = (p.optionen || []).findIndex(function (o) { return /farbe|color/i.test(o); });
      if (fi >= 0 && v.options) setTimeout(function () { galerieFarbe(v.options[fi]); }, 60);
    });
  }
  function staffel() { var s = window.LLKorb && window.LLKorb.staffel; return s && s.length ? s : [[2, 5], [3, 10], [4, 20]]; }
  function istKleid(i) {
    var C = window.LLKorb || {};
    if (C.socke && i.variant_id === C.socke.variantId) return false;
    if (i.handle === (C.aufpreisHandle || 'personalisierung')) return false;
    return !C.rabattTypen || C.rabattTypen.indexOf(i.product_type) >= 0;
  }

  class LLKaufkasten extends HTMLElement {
    connectedCallback() {
      if (this._bereit) return;
      this._bereit = true;
      this.n = typeof window.__llkkN === 'number' ? window.__llkkN : null;
      var self = this;
      this.liste = this.closest('.product-info__block-list') || this.parentNode;
      this.feld = this.querySelector('[data-llkk-familie]');
      this.querySelectorAll('.llkk__karte').forEach(function (k) {
        k.addEventListener('click', function () { self.modus(k.getAttribute('data-m'), true); });
      });
      this._holeFamilie();
      setTimeout(function () { self._holeFamilie(); }, 0);
      this.liste.setAttribute('data-llkk', '');
      this.modus(sitzung('llkk-modus') === 'familie' ? 'familie' : 'eins', false);
      this.stand();
      if (!window.__llkkStand) {
        window.__llkkStand = true;
        document.addEventListener('cart:change', function () { setTimeout(function () { var k = document.querySelector('ll-kaufkasten'); if (k) k.stand(); }, 300); });
      }
      this._kaufHaken();
      this._namenZeile();
      this._farbKacheln();
      this._geschwister();
    }

    /* „Gibt's auch als“ (Marian 2026-11-03): dieselbe Motiv-Linie in den anderen Produktarten (Hoodie, Zip-Hoodie,
       Sweatshirt, Shirt). Gleich heißt: gleicher Titel vor „ – “, gerendert in ll-kaufkasten.liquid. */
    _geschwister() {
      /* Ganz oben (Marian 2026-11-03): am Handy über dem Bild, am Desktop als Erstes in der Kaufkarte. Prestige baut den
         Kaufbereich beim Variantenwechsel neu, darum EIN Element für die ganze Seite, das nur umgehängt wird. */
      var alt = this.querySelector('[data-llkk-geschwister]');
      var g = window.__llkkGeschwister;
      if (g && g.__an) { if (alt && alt !== g) alt.remove(); this._geschwisterPlatz(g); return; }
      var box = g || alt;
      if (alt && alt !== box) alt.remove();
      if (!box) return;
      box.__an = true; window.__llkkGeschwister = box; this._geschwisterPlatz(box);
      window.addEventListener('resize', function () { var k = document.querySelector('ll-kaufkasten'); if (k) k._geschwisterPlatz(box); });
      /* Seit 2026-11-03 kommt die Leiste fertig mit der Seite (ll-kaufkasten.liquid). Nicht mehr nachladen: was später
         erscheint, schiebt die Seite nach unten (Marian: „wenn ich gerade klicken will, verrutscht die Seite“). */
      if (box.hasAttribute('data-fertig')) this._geschwisterPfeil(box);
    }

    /* Pfeil, wenn nicht alle Karten sichtbar sind (Marian 2026-11-03: „man sieht nicht, dass es noch T-Shirt gibt“). */
    _geschwisterPfeil(box) {
        if (box.querySelector('.llkk__weiter')) return;
        var reihe2 = box.querySelector('.llkk__geschwister-reihe');
        if (!reihe2) return;
        var pfeil = document.createElement('button');
        pfeil.type = 'button'; pfeil.className = 'llkk__weiter'; pfeil.setAttribute('aria-label', 'Weitere Produktarten');
        pfeil.innerHTML = '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true"><path d="M4.5 2l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
        box.appendChild(pfeil);
        var pruefe = function () { var mehr = reihe2.scrollWidth - reihe2.clientWidth - reihe2.scrollLeft > 4; box.toggleAttribute('data-mehr', mehr); };
        pfeil.addEventListener('click', function () { reihe2.scrollBy({ left: reihe2.clientWidth * 0.7, behavior: 'smooth' }); });
        reihe2.addEventListener('scroll', pruefe, { passive: true });
        window.addEventListener('resize', pruefe);
        setTimeout(pruefe, 50);
    }

    _geschwisterPlatz(box) {
      var produkt = this.closest('.product');
      if (!produkt || !box) return;
      var breit = window.matchMedia && window.matchMedia('(min-width: 1000px)').matches;
      var ziel = breit ? produkt.querySelector('.product-info') : produkt.querySelector('.product-gallery');
      if (!ziel) return;
      if (breit) { if (ziel.firstElementChild !== box) ziel.insertBefore(box, ziel.firstElementChild); }
      else if (ziel.previousElementSibling !== box) ziel.parentNode.insertBefore(box, ziel);
      box.toggleAttribute('data-oben', !breit);
    }

    /* Namenspreis im Familienpaket sichtbar machen: Zeile unter der Leiter und Hinweis am Namens-Aufpreis. */
    _namenZeile() {
      var nf = window.LLKorb && window.LLKorb.namenFamilie;
      var daten = document.querySelector('[data-llf-produkt]'), p = null;
      try { p = JSON.parse(daten.textContent); } catch (x) { p = null; }
      if (!nf || !p || !p.pers) return;
      var geld = function (c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' €'; };
      var z = this.querySelector('[data-llkk-namen]');
      if (z) z.hidden = true;
      this._nfText = 'ab ' + nf.ab + ' Teilen ' + geld(nf.preis);
    }

    /* Feinschliff wie bei Snocks: Maßband und „Nicht sicher welche Größe?“, runde Größen-Pillen, Schritt 3 als echte
       Überschrift in derselben Schrift. Läuft nach jedem Neuaufbau des Varianten-Wählers erneut. */
    /* Der Familien-Wähler steht als eigener Block unter dem Kaufknopf; hier gehört er hin. Nach einem Neuaufbau des
       Kaufbereichs (Variantenwechsel) gibt es ihn dort neu, darum läuft das auch im Feinschliff. */
    _holeFamilie() {
      var feld = this.feld;
      /* Seit 2026-11-03 rendert der Kaufkasten den Wähler selbst (übersteht so jeden Neuaufbau); ein alter Einzel-Block
         wird nur noch ausgeblendet. */
      /* Nur eine abgehängte Instanz räumt nicht auf: nach dem Neuaufbau durch Prestige gehört der Wähler der neuen
         <ll-kaufkasten>, und deren Block darf nie versteckt werden (Fehler bis 2026-11-03: nach der Größenwahl war der ganze
         Kaufkasten samt „Geschwister & Familie“ weg). */
      if (!this.isConnected) return;
      Array.prototype.forEach.call(document.querySelectorAll('ll-familie'), function (f) {
        if (feld.contains(f) || f.closest('ll-kaufkasten')) return;
        var alt = f.closest('.product-info__block-item');
        if (alt && !alt.querySelector('ll-kaufkasten')) alt.hidden = true; else if (!alt) f.hidden = true;
      });
      var fam = feld.querySelector('ll-familie');
      if (!fam) return;
      fam.setAttribute('data-im-kaufkasten', '');
      if (this.liste.getAttribute('data-llkk-modus') === 'familie') { var auf = fam.querySelector('.llf__auf'); if (auf && auf.getAttribute('aria-expanded') !== 'true') auf.click(); }
    }
    _feinschliff() {
      var self = this;
      this._holeFamilie();
      var felder = Array.prototype.slice.call(this.liste.querySelectorAll('.variant-picker__option'));
      felder.forEach(function (f) {
        var l = f.querySelector('legend');
        if (!l || !/gr(ö|oe)(ß|ss)e|size/i.test(l.textContent)) return;
        f.classList.add('llkk-groessen');
        /* Wie bei Snocks „Größe: M“: die gewählte Größe neben der Überschrift. */
        var an = f.querySelector('input[type="radio"]:checked'), lab = an && an.id ? f.querySelector('label[for="' + an.id + '"]') : null;
        var wert = f.querySelector('.llkk-gewaehlt');
        if (!wert) { wert = document.createElement('b'); wert.className = 'llkk-gewaehlt'; l.insertAdjacentElement('afterend', wert); }
        var t = lab ? lab.textContent.replace(/\s+/g, ' ').trim() : '';
        if (wert.textContent !== t) wert.textContent = t;
        var link = f.querySelector('.variant-picker__option-info button.link');
        if (link && !link.hasAttribute('data-llkk')) {
          link.setAttribute('data-llkk', '');
          link.innerHTML = '<svg viewBox="0 0 28 20" width="26" height="18" aria-hidden="true"><rect x="1.5" y="5" width="25" height="10" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="10" r="2.6" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M14 15v-3M17.5 15v-4M21 15v-3" stroke="currentColor" stroke-width="1.5"/></svg><span>Nicht sicher welche Größe?</span>';
          link.classList.add('llkk-massband');
        }
      });
      var pers = this.liste.querySelector('ll-personalisierung');
      if (pers && !(pers.previousElementSibling && pers.previousElementSibling.classList.contains('llkk-schritt'))) {
        var h = document.createElement('div');
        h.className = 'llkk-schritt';
        h.innerHTML = '<span class="llkk-nr">' + (felder.length + 1) + '</span><span>Personalisierung</span>';
        pers.parentNode.insertBefore(h, pers);
      }
      /* „In meine Tasche“ statt „In den Warenkorb“ (Marian 2026-11-03: der Warenkorb heißt jetzt „Deine Tasche“). */
      var kauf = this.liste.querySelector('.product-info__block-item[data-block-type="buy-buttons"] button[type="submit"]');
      if (kauf && !kauf._llGut && /warenkorb/i.test(kauf.textContent)) kauf.textContent = 'In meine Tasche';
      /* Personalisierung aufklappen: der Block fokussiert das Namensfeld und reißt die Seite dabei hin. Stattdessen
         ohne Sprung fokussieren und sanft dorthin scrollen. */
      var feld = pers && pers.querySelector('.ll-pers__name');
      if (feld && !feld._llSanft) {
        feld._llSanft = true;
        var echt = feld.focus;
        feld.focus = function () {
          echt.call(feld, { preventScroll: true });
          var r = feld.getBoundingClientRect();
          if (r.top < 80 || r.bottom > window.innerHeight - 80) window.scrollBy({ top: r.top - window.innerHeight * 0.4, behavior: 'smooth' });
        };
      }
      var preis = pers && pers.querySelector('.ll-pers__option-preis--aufpreis');
      if (preis && self._nfText && !preis.querySelector('small')) {
        var sm = document.createElement('small');
        sm.textContent = self._nfText;
        preis.appendChild(sm);
      }
    }

    /* Farben als Bildkacheln wie bei Snocks (Marian 2026-11-03): je Farbe der Kinder-Packshot von hinten (dort sitzt das
       Motiv), sonst von vorn, sonst irgendein Foto der Farbe, nie Baby. Farbcode aus der SKU (<linie>-<motiv>-<textil>-<farbe>-…).
       Prestige zeichnet den Varianten-Wähler bei jedem Wechsel neu, darum wacht ein Beobachter darüber. */
    _farbKacheln() {
      var self = this, daten = document.querySelector('[data-llf-produkt]'), p;
      try { p = JSON.parse(daten.textContent); } catch (x) { return; }
      var fi = -1;
      (p.optionen || []).forEach(function (o, i) { if (/farbe|color/i.test(o)) fi = i; });
      if (fi < 0 || !p.medien || !p.medien.length) { this._feinschliff(); return; }
      var code = {};
      p.varianten.forEach(function (v) { var t = String(v.sku || '').split('-'); if (t.length >= 4 && !code[v.o[fi]]) code[v.o[fi]] = t[3].toUpperCase(); });
      var bild = function (farbe) {
        var c = code[farbe]; if (!c) return null;
        var mit = function (stueck) { var m = p.medien.filter(function (x) { return x.n.indexOf(c + stueck) >= 0; })[0]; return m && m.u; };
        return mit('-KIDS-BACK') || mit('-KIDS-FRONT') || (p.medien.filter(function (x) { return x.n.indexOf('-' + c + '-') >= 0 && x.n.indexOf('BABY') < 0; })[0] || {}).u || null;
      };
      var anwenden = function () {
        var fs = Array.prototype.filter.call(self.liste.querySelectorAll('.variant-picker__option'), function (f) {
          var l = f.querySelector('legend'); return l && /farbe|color/i.test(l.textContent);
        })[0];
        if (!fs) return;
        fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
          var lab = inp.id && fs.querySelector('label[for="' + inp.id + '"]');
          if (!lab || lab.classList.contains('llkk-farbe')) return;
          var name = lab.textContent.replace(/\s+/g, ' ').trim();
          var u = bild(name);
          if (!u) return;
          lab.classList.add('llkk-farbe');
          /* B1 (Marian 2026-11-03): nur das Foto, der Name steht oben in „Farbe: …“. */
          lab.innerHTML = '<img src="' + u + '" alt="" loading="lazy" width="150" height="150"><span class="llkk-sr">' + name.replace(/</g, '&lt;') + '</span>';
          lab.title = name;
        });
        fs.classList.add('llkk-farben');
      };
      var alt = anwenden;
      anwenden = function () { alt(); self._feinschliff(); };
      anwenden();
      var warte = null;
      new MutationObserver(function () { clearTimeout(warte); warte = setTimeout(anwenden, 30); }).observe(this.liste, { childList: true, subtree: true });
    }

    /* ---------- Nach dem Kauf (Marian 2026-11-03, Vorbild Snocks) ----------
       Knopf zeigt kurz „Gute Wahl! 👍“. Fehlt noch eine Stufe der Staffel, kommt zuerst das Angebot für den nächsten Schritt
       („Spare 5 % mit einem zweiten Teil“, seit 2026-11-03 auch „Noch 1 Teil, dann −10 %“ / „… −20 %“) und erst danach der
       Warenkorb (ll-korb.js wartet, solange window.LLKorbPause läuft). Ab der höchsten Stufe gleich der Warenkorb. */
    _kaufHaken() {
      /* Prestige baut den Kaufbereich beim Varianten-Wechsel neu, dann gibt es eine neue <ll-kaufkasten>-Instanz.
         Die Zuhörer hängen deshalb EINMAL an der Seite und fragen immer die gerade eingehängte Instanz. */
      if (window.__llkkHaken) return;
      window.__llkkHaken = true;
      var aktiv = function () { return document.querySelector('ll-kaufkasten'); };
      window.addEventListener('submit', function (e) {
        var self = aktiv(), f = e.target;
        if (!self || !f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
        if (!self.liste.contains(f) && !(f.id && self.liste.querySelector('[form="' + f.id + '"]'))) return;
        if (self.liste.getAttribute('data-llkk-modus') === 'familie') return;
        var hoechste = staffel().reduce(function (m, x) { return Math.max(m, x[0]); }, 0);
        if (self.n === null || self.n < hoechste - 1) { window.__llkkWartet = true; window.LLKorbPause = Date.now() + 6000; }
      }, true);
      var nachKauf = function () {
        var self = aktiv();
        if (!self) return;
        self._guteWahl();
        if (!window.__llkkWartet) return;
        window.__llkkWartet = false;
        self._angebot();
      };
      document.addEventListener('variant:add', nachKauf);
      document.addEventListener('ll:personalisierung:hinzugefuegt', nachKauf);
    }
    _guteWahl() {
      var k = this.liste.querySelector('.product-info__block-item[data-block-type="buy-buttons"] button[type="submit"]');
      if (!k || k._llGut) return;
      k._llGut = true;
      var vorher = k.innerHTML;
      setTimeout(function () { k.innerHTML = '<span>Gute Wahl! 👍</span>'; }, 60);
      setTimeout(function () { k.innerHTML = vorher; k._llGut = false; }, 1900);
    }
    _korbAuf() {
      window.LLKorbPause = 0;
      if (typeof window.LLKorbOeffnen === 'function') window.LLKorbOeffnen();
    }
    _angebot() {
      var self = this;
      var daten = document.querySelector('[data-llf-produkt]');
      var produkt = null;
      try { produkt = daten ? JSON.parse(daten.textContent) : null; } catch (x) { produkt = null; }
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var kleider = (cart.items || []).filter(istKleid);
          var n = kleider.reduce(function (x, i) { return x + i.quantity; }, 0);
          /* Shopify stellt das zuletzt Hinzugefügte nach oben. */
          var item = kleider[0];
          var naechste = staffel().slice().sort(function (a, b) { return a[0] - b[0]; }).filter(function (x) { return x[0] > n; })[0];
          if (n < 1 || !naechste || !item || !produkt) { self._korbAuf(); return; }
          var summe = kleider.reduce(function (x, i) { return x + i.original_line_price; }, 0);
          self._zeigeAngebot(produkt, item, { n: n, teile: naechste[0], prozent: naechste[1], summe: summe });
        })
        .catch(function () { self._korbAuf(); });
    }
    _zeigeAngebot(produkt, item, stufe) {
      var self = this;
      stufe = stufe || { n: 1, teile: 2, prozent: 5, summe: item.original_line_price };
      var zwei = stufe.prozent, fehlt = stufe.teile - stufe.n, erstes = stufe.n === 1;
      var hoechste = staffel().reduce(function (m, x) { return x[0] > m[0] ? x : m; }, [0, 0]);
      var fi = -1, gi = -1;
      (produkt.optionen || []).forEach(function (o, i) { if (/farbe|color/i.test(o)) fi = i; else if (/gr(ö|oe)(ß|ss)e|size/i.test(o)) gi = i; });
      var gekauft = produkt.varianten.filter(function (v) { return v.id === item.variant_id; })[0];
      var farbe = gekauft && fi >= 0 ? gekauft.o[fi] : null;
      var passend = produkt.varianten.filter(function (v) { return v.ok && (fi < 0 || v.o[fi] === farbe); });
      if (!passend.length || gi < 0) { this._korbAuf(); return; }
      var wahl = passend.filter(function (v) { return v.id === item.variant_id; })[0] || null;
      var geld = function (c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; };
      var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      var w = document.createElement('div');
      w.className = 'llkk-angebot';
      w.setAttribute('role', 'dialog');
      w.setAttribute('aria-modal', 'true');
      w.setAttribute('aria-labelledby', 'llkk-angebot-titel');
      var bild = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
      var zeichne = function () {
        var p = wahl ? wahl.preis : passend[0].preis;
        var spar = Math.round((stufe.summe + p * fehlt) * zwei / 100);
        w.innerHTML = '<div class="llkk-angebot__schleier" data-a="nein"></div><div class="llkk-angebot__karte">' +
          '<button type="button" class="llkk-angebot__zu" data-a="nein" aria-label="Schließen">×</button>' +
          '<h2 id="llkk-angebot-titel">' + (erstes ? 'Spare ' + zwei + ' % mit einem zweiten Teil.' : 'Noch ' + (fehlt === 1 ? '1 Teil' : fehlt + ' Teile') + ', dann −' + zwei + ' % auf alles.') + '</h2>' +
          '<p class="llkk-angebot__unter">' + (erstes ? 'Gleiches Motiv, gleiche Farbe, andere Größe. Zum Beispiel für Geschwister oder für dich.' : 'Du hast ' + stufe.n + ' Teile in deiner Tasche. Mit ' + (fehlt === 1 ? 'einem weiteren' : fehlt + ' weiteren') + ' gilt −' + zwei + ' % auf alles, zum Beispiel dasselbe in einer anderen Größe.') + '</p>' +
          '<div class="llkk-angebot__teil"><div class="llkk-angebot__bild">' + (bild ? '<img src="' + esc(bild) + '" alt="" width="200" height="200">' : '') + '<span>−' + zwei + ' %</span></div>' +
          '<div class="llkk-angebot__info"><strong>' + esc(item.product_title) + '</strong><span>' + esc(farbe || '') + '</span>' +
          '<div class="llkk-angebot__groessen">' + passend.map(function (v) {
            return '<button type="button" data-a="gr" data-v="' + v.id + '" aria-pressed="' + (wahl && wahl.id === v.id) + '">' + esc(v.o[gi]) + '</button>';
          }).join('') + '</div>' +
          '<span class="llkk-angebot__preis">' + geld(p) + (wahl ? (erstes ? ' · zusammen sparst du ' : ' · dann sparst du insgesamt ') + geld(spar) : '') + '</span>' +
          '<button type="button" class="llkk-angebot__dazu" data-a="dazu"' + (wahl ? '' : ' disabled') + '>' + (wahl ? 'In meine Tasche' : 'Bitte Größe wählen') + '</button></div></div>' +
          (stufe.teile < hoechste[0] ? '<button type="button" class="llkk-angebot__familie" data-a="familie">Für die ganze Familie? Ab ' + hoechste[0] + ' Teilen −' + hoechste[1] + ' % auf alles</button>' : '') +
          '<button type="button" class="llkk-angebot__nein" data-a="nein">Nein danke</button></div>';
      };
      var zu = function (korb) {
        document.removeEventListener('keydown', taste);
        w.remove();
        document.documentElement.style.overflow = '';
        if (korb) self._korbAuf(); else window.LLKorbPause = 0;
      };
      var taste = function (e) { if (e.key === 'Escape') zu(true); };
      w.addEventListener('click', function (e) {
        var b = e.target.closest('[data-a]');
        if (!b || b.disabled) return;
        var a = b.getAttribute('data-a');
        if (a === 'nein') zu(true);
        else if (a === 'gr') { wahl = passend.filter(function (v) { return String(v.id) === b.getAttribute('data-v'); })[0]; zeichne(); }
        else if (a === 'familie') { zu(false); self.modus('familie', true); }
        else if (a === 'dazu') {
          b.disabled = true; b.textContent = 'Einen Moment …';
          window.LLKorbPause = Date.now() + 6000;
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: wahl.id, quantity: 1 }] }),
          }).then(function (r) {
            if (!r.ok) throw new Error();
            return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (x) { return x.json(); });
          }).then(function (cart) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'll:angebot', cart: cart } }));
            zu(true);
          }).catch(function () { b.disabled = false; b.textContent = 'Nochmal versuchen'; });
        }
      });
      document.addEventListener('keydown', taste);
      zeichne();
      document.body.appendChild(w);
      document.documentElement.style.overflow = 'hidden';
      var erst = w.querySelector('.llkk-angebot__groessen button');
      if (erst) erst.focus({ preventScroll: true });
    }
    modus(m, klick) {
      this.querySelectorAll('.llkk__karte').forEach(function (k) { var an = String(k.getAttribute('data-m') === m); k.setAttribute('aria-pressed', an); k.setAttribute('aria-checked', an); });
      this.liste.setAttribute('data-llkk-modus', m);
      this.feld.hidden = m !== 'familie';
      sitzung('llkk-modus', m === 'familie' ? 'familie' : null);
      if (m === 'familie') {
        var fam = this.feld.querySelector('ll-familie');
        var auf = fam && fam.querySelector('.llf__auf');
        if (auf && auf.getAttribute('aria-expanded') !== 'true') auf.click();
        if (klick && this.feld.scrollIntoView) {
          var r = this.feld.getBoundingClientRect();
          if (r.top > window.innerHeight * 0.8) this.feld.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
    /* „Du bist hier“: wie viele Kleidungsstücke schon im Korb liegen und was das nächste bringt. */
    stand() {
      var self = this;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = 0;
          (cart.items || []).forEach(function (i) { if (istKleid(i)) n += i.quantity; });
          self.n = n;
          window.__llkkN = n;
          var st = staffel();
          self.querySelectorAll('.llkk__leiter li').forEach(function (li) {
            var ab = +li.getAttribute('data-ab');
            li.toggleAttribute('data-erreicht', n >= ab);
            li.toggleAttribute('data-naechste', ab === n + 1);
          });
          var t = self.querySelector('[data-llkk-stand]');
          if (!t) return;
          if (!n) { t.textContent = 'Gilt für alle Kleidungsstücke im Warenkorb, auch verschiedene Motive.'; return; }
          var p = 0; st.forEach(function (s) { if (n + 1 >= s[0]) p = s[1]; });
          var max = st[st.length - 1];
          t.textContent = n >= max[0]
            ? 'Im Warenkorb: ' + n + ' Teile. Familienpreis −' + max[1] + ' % ist aktiv, jedes weitere Teil auch.'
            : 'Im Warenkorb: ' + n + (n === 1 ? ' Teil' : ' Teile') + '. Mit diesem Teil: −' + p + ' % auf alles.';
        })
        .catch(function () {});
    }
  }
  customElements.define('ll-kaufkasten', LLKaufkasten);
})();
